import React, { useContext } from 'react';
import { Button, Form } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { AiFillCaretDown } from "react-icons/ai";
import { MdDelete } from 'react-icons/md';

import { NewContext } from '../../../Context/NewContext';

import './thead.css';

export const THead = ({ simpleFields = [], dropdownFields = [], actionField = true }) => {
    // console.log(tableFields);
    const { currentTableData, checkedValues, handleFilterChange, handleSelectAll } = useContext(NewContext);
    return (
        <thead>
            <tr className='align-middle'>
                <th className='select-all-th'>
                    <Form.Check
                        type={'checkbox'}
                        checked={currentTableData.length > 0 && currentTableData.length === checkedValues.length}
                        onChange={handleSelectAll}
                        // label={`Select All`}
                        className='d-flex align-items-center'
                    />
                </th>
                {/* {
                    tableFields?.map((_ele, i) => (
                        <th key={i}>
                            {
                                ["Active"].includes(_ele) ?
                                    <div className="table-dropdown position-relative d-inline-block">
                                        <button className="dropbtn d-flex align-items-center">{_ele}<AiFillCaretDown className='ms-1 drop-carat' size={'14px'} /></button>
                                        <Form className="dropdown-content">
                                            <Form.Check
                                                className='mb-0 py-2 px-3 d-flex align-items-center'
                                                label="On"
                                                type={'radio'}
                                                name={`is${_ele}`}
                                                id={`is${_ele}-${i}`}
                                                onChange={handleFilterChange}
                                                value={true}
                                            />
                                            <Form.Check
                                                className='mb-0 py-2 px-3 d-flex align-items-center'
                                                label="Off"
                                                type={'radio'}
                                                name={`is${_ele}`}
                                                id={`is${_ele}-${i + 1}`}
                                                onChange={handleFilterChange}
                                                value={false}
                                            />
                                            <Form.Check
                                                className='mb-0 py-2 px-3 d-flex align-items-center'
                                                label="All"
                                                type={'radio'}
                                                name={`is${_ele}`}
                                                id={`is${_ele}-${i + 2}`}
                                                onChange={handleFilterChange}
                                                value={""}
                                                defaultChecked={`${_ele.charAt(0).toLowerCase() + _ele.slice(1) === "" && true}`}
                                            />
                                        </Form>
                                    </div>
                                    : <>{_ele}</>
                            }
                        </th>
                    ))
                } */}
                {
                    simpleFields && simpleFields?.map((_string, i) => (
                        <th key={i}>{_string}</th>
                    ))
                }
                {
                    dropdownFields && dropdownFields?.map((_dropdown, i) => (
                        <th key={i}>
                            {
                                dropdownFields.includes(_dropdown) &&
                                <div className="table-dropdown position-relative d-inline-block">
                                    <button className="dropbtn d-flex align-items-center">{_dropdown}<AiFillCaretDown className='ms-1 drop-carat' size={'14px'} /></button>
                                    <Form className="dropdown-content">
                                        <Form.Check
                                            className='mb-0 py-2 px-3 d-flex align-items-center'
                                            label="On"
                                            type={'radio'}
                                            name={`is${_dropdown}`}
                                            id={`is${_dropdown}-${i}`}
                                            onChange={handleFilterChange}
                                            value={true}
                                        />
                                        <Form.Check
                                            className='mb-0 py-2 px-3 d-flex align-items-center'
                                            label="Off"
                                            type={'radio'}
                                            name={`is${_dropdown}`}
                                            id={`is${_dropdown}-${i + 1}`}
                                            onChange={handleFilterChange}
                                            value={false}
                                        />
                                        <Form.Check
                                            className='mb-0 py-2 px-3 d-flex align-items-center'
                                            label="All"
                                            type={'radio'}
                                            name={`is${_dropdown}`}
                                            id={`is${_dropdown}-${i + 2}`}
                                            onChange={handleFilterChange}
                                            value={""}
                                            defaultChecked={`${_dropdown.charAt(0).toLowerCase() + _dropdown.slice(1) === "" && true}`}
                                        />
                                    </Form>
                                </div>
                            }
                        </th>
                    ))
                }
                {
                    actionField && <th>Actions</th>
                }
            </tr>
        </thead>
    )
}

export default THead